export default __webpack_public_path__ + "static/Entenda0064-f102fc6b6cc44e64fc0f8df5540e93ce.jpg";